<template>
  <div>
    <div style="margin-bottom: 10px;">
      <el-button type="primary" @click="dialogVisible = true">新增课程</el-button>
    </div>
    <el-card shadow="never">
      <el-table :data="tableData">
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="courseName" label="课程名称" />
        <el-table-column prop="status" label="状态" width="80">
          <template #default="scope">
            <el-tag v-if="scope.row.isPublished" type="success">发布</el-tag>
            <el-tag v-else type="danger">隐藏</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="studyCount" label="学习人数" />
        <el-table-column prop="videoCount" label="视频数" />
        <el-table-column prop="lastUpdateTime" label="最后更新时间" width="180" />
        <el-table-column label="操作" width="220" fixed="right">
          <template #default="scope">
            <el-button type="text" size="small" @click="openVideoDrawer(scope.row)">视频管理</el-button>
            <el-button type="text" size="small" @click="openCategory(scope.row)">类目管理</el-button>
            <el-button type="text" size="small" @click="editItem(scope.row)" style="margin-right: 10px;">编辑</el-button>
            <el-popconfirm title="确定要删除吗？" @confirm="deleteItem(scope.row.id)">
              <template #reference>
                <el-button type="text" size="small">删除</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

    </el-card>

    <!-- 新增品牌 -->
    <el-dialog :visible.sync="dialogVisible" :title="form.courseId ? '编辑课程' : '添加课程'" width="500px"
      :close-on-click-modal="false">
      <el-form :model="form" label-width="80px" label-position="right">
        <el-form-item label="课程名称:">
          <el-input v-model="form.courseName" />
        </el-form-item>
        <el-form-item label="发布:">
          <el-switch v-model="form.isPublished" :active-value="true" :inactive-value="false" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveItem">确定</el-button>
      </template>
    </el-dialog>

    <categoryDialog ref="categoryDialog" />
    <videoDrawer ref="videoDrawer" />
  </div>
</template>


<script>
import uploadCover from '@/components/upload-cover/upload-cover.vue'
import categoryDialog from './components/categoryDialog.vue';
import videoDrawer from './components/videoDrawer.vue';
export default {
  components: {
    uploadCover,
    categoryDialog,
    videoDrawer
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.form = {
          isPublished: true,
        }
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        isPublished: true,
      },
      totalNum: 0,
      tableData: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const res = await this.$request.post("/cms/courseChapters/list", {
        size: 1000,
        current: 0
      })
      if (res.data.code == 200) {
        this.tableData = res.data.data.records
        this.totalNum = res.data.data.total
      }
    },
    async deleteItem(id) {
      const res = await this.$request.get("/cms/courseChapters/delete?courseId=" + id)
      if (res.data.code == 200) {
        this.$message.success("删除成功")
        this.getList()
      }
    },
    editItem(row) {
      row.courseId = row.id
      this.form = this.$deepClone(row)
      this.dialogVisible = true
    },
    async saveItem() {
      const res = await this.$request.post(this.form.courseId ? "/cms/courseChapters/update" : "/cms/courseChapters/add", this.form)
      if (res.data.code == 200) {
        this.$message.success("操作成功")
        this.dialogVisible = false
        this.getList()
      }
    },
    openCategory(row) {
      this.$refs.categoryDialog.open(row)
    },
    openVideoDrawer(row) {
      this.$refs.videoDrawer.open(row)
    },
  }
}
</script>